import createGeocoding from '@shared/local-jobs-geocoding';

/**
 * Returns a locationField object which contains and input field with location
 * autocomplete, a use current selection button, and it's validation method.
 * The parameters can be passed in any order
 * and some are optional, with default values.
 * @param {Object} options configuration for createLocationField
 * @param {String} options.inputFieldId The id to use for the text field.
                                  This is required.
 * @param {String} options.locationBtnId The id to use for the pin button.
                                  This is required.
 * @param {String} options.locationErrorAlertId container for
 *                                locationField errors.
                                  This is required.
 * @callback options.autoCompleteCallback Callback function after selecting
                                  from the autocomplete dropdown.
 * @param {Object} options.parentForm locationField field will be
 *                                attached to this form.
 *                                parentForm should have a createHiddenField
                                  method which returns a html input field.
 */
export function createLocationField({
  inputFieldId,
  locationBtnId,
  errorAlertId,
  autoCompleteCallback,
  parentForm,
  initialLocation,
}) {
  let selectedFromDropdown = false;
  const inputField = document.getElementById(inputFieldId);
  createGeocoding({
    autoCompleteElement: inputFieldId,
    autoCompleteCallback: onLocationSelected,
    reverseGeocodingElement: locationBtnId,
    reverseGeocodingSuccessCallback: onLocationSelected,
    initialLocation,
  });

  let typedSomething = false;

  function onLocationSelected(geoInfo) {
    if (geoInfo) {
      setLocationHiddenValues(geoInfo);
      if (autoCompleteCallback) {
        autoCompleteCallback(geoInfo);
      }
      typedSomething = false;
    }
  }

  inputField.addEventListener('input', () => {
    selectedFromDropdown = false;
    typedSomething = true;
  });

  inputField.addEventListener('keypress', event => {
    if (event.which === 13) {
      event.preventDefault();
    }
  });

  inputField.addEventListener('focusout', () => {
    if (typedSomething) {
      validate();
    }
  });

  function displayLocationError() {
    const errorAlert = document.getElementById(errorAlertId);
    if (errorAlert) {
      errorAlert.classList.remove('is-hidden');
    }
  }

  function hideLocationError() {
    const errorAlert = document.getElementById(errorAlertId);
    if (errorAlert) {
      errorAlert.classList.add('is-hidden');
    }
  }

  function setLocationHiddenValues(newLocation) {
    selectedFromDropdown = true;
    hideLocationError();
    parentForm.setLocation(newLocation);
  }

  function validate() {
    if (selectedFromDropdown) {
      hideLocationError();
      return true;
    }
    displayLocationError();
    return false;
  }
  return {
    inputField,
    validate,
  };
}
